import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

export default function NotFound() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { lang } = useParams<{ lang: string }>();
  const currentLang = lang || "pt";

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0 font-heading">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-primary-50 text-primary-500 mx-auto mb-6">
          <i className="ri-error-warning-line text-3xl"></i>
        </div>
        <h1 className="text-xl md:text-2xl font-semibold mt-6 text-foreground-950 font-heading">{t("notFound.title")}</h1>
        <p className="mt-2 text-sm text-foreground-400 font-mono">{location.pathname}</p>
        <button
          onClick={() => navigate(`/${currentLang}/`)}
          className="mt-6 px-6 py-2.5 bg-primary-500 text-white rounded-lg font-medium hover:bg-primary-600 transition-all whitespace-nowrap"
        >
          {t("notFound.back")}
        </button>
      </div>
    </div>
  );
}